import { theme } from '@theme';
import styled from 'styled-components';

export const NotificationDroplist = styled.div.attrs({
  className: 'third',
})`
  display: block;
  width: 300px;
  border: 1px solid ${theme.palette.toolTipBackground};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  height: auto;
  position: absolute;
  background: ${theme.palette.text.white};
  top: 66px;
  left: -123px;
  z-index: 1000;
`;

export const DroplistHeader = styled.div`
  border-bottom: 1px solid ${theme.palette.darkPurpleEUI};

  h3 {
    line-height: 32px;
    color: ${theme.palette.toolTipBackground};
    text-align: center;
    font-size: ${theme.typography.fontSize16}px;
    font-weight: ${theme.typography.fontWeights.semibold};
    padding: 10px 0;
    margin: 0;
    text-rendering: optimizelegibility;
    cursor: default;
  }
`;

export const WhitePurpleTip = styled.div`
  display: block;
  position: absolute;
  width: 32px;
  height: 14px;
  top: -10px;
  left: 136px;
  transform: rotate(180deg);
`;

export const NavbarButton = styled.li`
  border-left: 1px solid ${theme.palette.darkPurpleFive};
  border-right: 1px solid ${theme.palette.purpleSix};
  float: left;
  position: relative;
  display: block;
  height: 60px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
    a {
      transition: border-bottom-width 0.15s ease-in;
      border-bottom-width: 6px;
    }
  }

  @media (max-width: 992px) {
    > a {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;

export const FavoriteDealsIconWrapper = styled.span`
  height: 60px;
  padding: 15px 18px;
  line-height: 30px;
  transition: border-bottom-width 0.15s ease-in;
  border-bottom-width: 0px;
  position: relative;
  color: ${theme.palette.text.white};
  -webkit-touch-callout: none;
  user-select: none;
  user-select: none;
  display: block;
  text-decoration: none;
`;
